import * as H from 'history';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router';
import { PageForbidden } from 'routes/errors/PageForbidden/PageForbidden';
import { IAppStore } from 'stores/AllStores';

interface IPrivateRoute extends RouteProps {
    store?: IAppStore;
    authorizedUserTypes?: string[]
}

// Component
@inject('store')
@observer
export class PrivateRoute extends React.Component<IPrivateRoute, {}> {
    constructor(props: IPrivateRoute) {
        super(props);
    }

    public render() {
        // Prepare props
        const {['store']: deleted, ...newProps} = this.props;

        // Render
        return (
            <Route {...newProps} component={null} render={this.validateRoute} />
        );
    }

    private validateRoute = (props: RouteComponentProps<any>): React.ReactNode | undefined => {
        const { store, component, authorizedUserTypes } = this.props;
        if (store.user.isLoggedIn && typeof component !== 'undefined') {
            return React.createElement(component as any, props);
        } else {
            return <PageForbidden user={this.props.store.user} history={props.history} location={props.location} />;
        }
    };
}

export default PrivateRoute;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/route/private/PrivateRoute.tsx